<template>
  <div class="inbox-container">
    <!-- Folder Tabs -->
    <v-card class="mb-4" flat>
      <v-tabs
        v-model="activeTab"
        color="primary"
        align-tabs="center"
        class="folder-tabs"
      >
        <v-tab value="all">
          <v-icon start>mdi-inbox</v-icon>
          الكل ({{ totalEmailCount }})
        </v-tab>
        
        <v-tab
          v-for="folder in userFolders"
          :key="folder.id"
          :value="folder.id.toString()"
        >
          <v-icon start :color="folder.color">mdi-folder</v-icon>
          {{ folder.name }} ({{ folder.mails.length || 0 }})
          <v-menu location="bottom" offset-y>
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                icon
                size="x-small"
                variant="text"
                @click.stop
                class="mr-1"
              >
                <v-icon size="small">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list density="compact">
              <v-list-item @click="editFolder(folder)">
                <template v-slot:prepend>
                  <v-icon size="small">mdi-pencil</v-icon>
                </template>
                <v-list-item-title>تعديل</v-list-item-title>
              </v-list-item>
              <v-list-item @click="confirmDeleteFolder(folder)">
                <template v-slot:prepend>
                  <v-icon size="small" color="error">mdi-delete</v-icon>
                </template>
                <v-list-item-title class="text-error">حذف</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-tab>
        
        <v-tab 
        v-if="hasPermission('admin.user-folders.store')"
        value="add" @click="openCreateFolderDialog">
          <v-icon start>mdi-folder-plus</v-icon>
          إضافة مجلد
        </v-tab>
      </v-tabs>
    </v-card>

    <!-- Toolbar -->
    <v-card class="mb-4 inbox-toolbar" flat>
      <v-card-text class="pa-2">
        <v-row align="center" no-gutters>
          <v-col cols="auto" class="ml-2">
            <v-checkbox
              v-model="selectAll"
              hide-details
              density="compact"
              color="primary"
              @change="toggleSelectAll"
            ></v-checkbox>
          </v-col>
          
          <v-col cols="auto">
            <v-menu location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon
                  variant="text"
                  size="small"
                >
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list density="compact">
                <v-list-item @click="selectAll = true; toggleSelectAll()">
                  <v-list-item-title>تحديد الكل</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectAll = false; toggleSelectAll()">
                  <v-list-item-title>إلغاء تحديد الكل</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectRead()">
                  <v-list-item-title>تحديد المقروءة</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectUnread()">
                  <v-list-item-title>تحديد غير المقروءة</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          
          <v-col cols="auto">
            <v-btn
              icon
              variant="text"
              size="small"
              :disabled="!hasSelected"
              @click="refreshMessages"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>
          
      
          
          <v-col cols="auto">
            <v-btn
              icon
              variant="text"
              size="small"
              :disabled="!hasSelected"
              @click="markAsRead"
            >
              <v-icon>mdi-email-open-outline</v-icon>
            </v-btn>
          </v-col>
          
          <v-col cols="auto">
            <v-btn
              icon
              variant="text"
              size="small"
              :disabled="!hasSelected"
              @click="markAsUnread"
            >
              <v-icon>mdi-email-outline</v-icon>
            </v-btn>
          </v-col>
          
          <!-- <v-col cols="auto">
            <v-btn
              v-if="hasPermission('admin.mails.delete')"
              icon
              variant="text"
              size="small"
              color="error"
              :disabled="!hasSelected"
              @click="confirmDeleteSelected"
            >
              <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
          </v-col> -->
          
          <v-col cols="auto">
            <v-menu location="bottom" v-if="activeTab !== 'all' && activeTab !== 'add'">
              <template v-slot:activator="{ props }">
                <v-btn

                  v-bind="props"
                  icon
                  variant="text"
                  size="small"
                  color="info"
                  :disabled="!hasSelected"
                >
                  <v-icon>mdi-folder-move</v-icon>
                </v-btn>
              </template>
              <v-list density="compact">
                <v-list-item @click="moveToInbox">
                  <template v-slot:prepend>
                    <v-icon color="primary">mdi-inbox</v-icon>
                  </template>
                  <v-list-item-title>نقل إلى البريد الوارد</v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item
                  v-for="folder in otherFolders"
                  :key="folder.id"
                  @click="moveToFolder(folder)"
                >
                  <template v-slot:prepend>
                    <v-icon :color="folder.color">mdi-folder</v-icon>
                  </template>
                  <v-list-item-title>{{ folder.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          
          <v-spacer></v-spacer>
          
          <v-col cols="auto">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="بحث في البريد"
              single-line
              hide-details
              density="compact"
              variant="outlined"
              class="search-field"
            ></v-text-field>
          </v-col>
          
          <v-col cols="auto" class="mr-2">
            <v-btn
              icon
              variant="text"
              size="small"
              @click="toggleFilterMenu"
            >
              <v-icon>mdi-filter-outline</v-icon>
            </v-btn>
            <v-menu
              v-model="showFilterMenu"
              location="bottom"
              :close-on-content-click="false"
            >
              <v-card min-width="300">
                <v-card-title class="text-subtitle-1">تصفية البريد</v-card-title>
                <v-card-text>
                  <v-radio-group v-model="filter" hide-details>
                    <v-radio value="all" label="الكل"></v-radio>
                    <v-radio value="unread" label="غير مقروء"></v-radio>
                    <v-radio value="read" label="مقروء"></v-radio>
                    <v-radio value="important" label="مهم"></v-radio>
                  </v-radio-group>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    @click="showFilterMenu = false"
                  >
                    إغلاق
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Messages List -->
    <v-card class="inbox-list" flat>
      <div v-if="groupedMessages.length === 0" class="text-center pa-8">
        <v-icon size="64" color="grey-lighten-1" class="mb-4">mdi-email-outline</v-icon>
        <div class="text-h6 text-grey">لا توجد رسائل</div>
      </div>
      
      <div v-for="group in groupedMessages" :key="group.date.toDateString()">
        <!-- Date Header -->
        <v-card 
          class="ma-2 date-header" 
          flat 
          color="white"
          :class="{ 'expanded': expandedDates[group.date.toDateString()] }"
          @click="toggleDateExpansion(group.date.toDateString())"
        >
          <v-card-text class="py-3 px-4 d-flex align-center justify-center">
            <v-icon 
              :class="{ 'rotated': expandedDates[group.date.toDateString()] }" 
              class="mr-2 transition-transform"
            >
              mdi-chevron-right
            </v-icon>
            <span class="text-subtitle-1 font-weight-medium">
              {{ formatDateHeader(group.date) }}
            </span>
            <!-- <v-chip size="small" class="mr-2" color="primary" variant="outlined">
              {{ group.messages.length }}
            </v-chip> -->
          </v-card-text>
        </v-card>
        
        <!-- Messages for this date -->
        <v-expand-transition>
          <div v-show="expandedDates[group.date.toDateString()]">
            <v-list lines="three" density="compact" class="pa-0">
                             <template v-for="message in group.messages" :key="message.id">
          <v-list-item style="align-content: center;"
            :class="{
              'unread-message': !message.read,
              'selected-message': selectedMessages.includes(message.id)
            }"
            @click="openMessage(message)"
                  class="mx-2 mb-1 rounded"
          >
            <template v-slot:prepend>
              <div class="d-flex align-center" >
              <v-checkbox
                :model-value="selectedMessages.includes(message.id)"
                @update:model-value="toggleMessageSelection(message.id)"
                @click.stop
                hide-details
                density="compact"
                color="primary"
              ></v-checkbox></div>
            </template>

            <v-list-item-title>
                    <div class="d-flex align-center mail-row">
                      <!-- Sender section - fixed width -->
                      <div class="sender-section">
                        <span class="font-weight-bold">{{ message.senderDepartment }}</span>
                <!-- <v-chip
                  v-if="message.urgent"
                  size="x-small"
                  color="error"
                  variant="flat"
                          class="ml-1"
                >
                  عاجل
                </v-chip> -->
                <v-icon
                  v-if="message.important"
                  color="warning"
                  size="small"
                          class="ml-1"
                >
                  mdi-star
                </v-icon>
                <v-icon
                  v-if="message.attachment"
                  color="grey"
                  size="small"
                          class="ml-1"
                >
                  mdi-paperclip
                </v-icon>
                      </div>
                      
                      <!-- Priority section - fixed width -->
                      <div class="priority-section">
                        <v-chip 
                          color="primary" 
                          variant="outlined" 
                          size="x-small"
                          v-if="message.priority"
                        >
                          {{ message.priority }}
                        </v-chip>
                      </div>
                      <div class="subject-section">
                        <span class="text-subtitle-2 font-weight-medium"> الإشاري: {{ message.ref || 'غير متوفر' }}</span>
                      </div>
                      <div class="subject-section">
                        <span class="text-subtitle-2 font-weight-medium"> {{ message.mailType || 'غير متوفر' }}</span>
                      </div>

                      <!-- Subject section - flexible width -->
                      <div class="subject-section">
                        <span class="text-subtitle-2 font-weight-medium">{{ message.subject }}</span>
                      </div>
                      
                      <!-- Preview section - flexible width -->
                      <div class="preview-section">
                        <span class="text-body-2 text-grey-darken-1">{{ stripHtml(message.preview) }}</span>
                      </div>
                      
                      <!-- Time section - fixed width -->
                      <div class="time-section">
                        <span class="text-body-2 text-grey">{{ formatTime(message.date) }}</span>
                        <div v-if="message.marginalizations && message.marginalizations.length > 0" class="mt-1">
                          
                        </div>
                      </div>
              </div>
            </v-list-item-title>

               

            <template v-slot:append>
              <v-menu location="start">
                <template v-slot:activator="{ props }">
                  <v-btn
                    v-bind="props"
                    icon
                    variant="text"
                    size="small"
                    @click.stop
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list density="compact">
                  <v-list-item @click="markSingleAsRead(message)">
                    <template v-slot:prepend>
                      <v-icon>mdi-email-open-outline</v-icon>
                    </template>
                    <v-list-item-title>وضع علامة كمقروء</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="markSingleAsUnread(message)">
                    <template v-slot:prepend>
                      <v-icon>mdi-email-outline</v-icon>
                    </template>
                    <v-list-item-title>وضع علامة كغير مقروء</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="toggleImportant(message)">
                    <template v-slot:prepend>
                      <v-icon>{{ message.important ? 'mdi-star-off' : 'mdi-star' }}</v-icon>
                    </template>
                    <v-list-item-title>
                      {{ message.important ? 'إزالة أهمية' : 'وضع علامة مهم' }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                  v-if="hasPermission('admin.mail-marginalizations.store')"
                  @click="openMarginalizationDialog(message)">
                    <template v-slot:prepend>
                      <v-icon color="info">mdi-comment-plus</v-icon>
                    </template>
                    <v-list-item-title>إضافة تهميش</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="hasPermission('admin.mails.history')" @click="openTrackMailDialog(message)">
                    <template v-slot:prepend>
                      <v-icon color="primary">mdi-radar</v-icon>
                    </template>
                    <v-list-item-title>تتبع الرسالة</v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-subheader>نقل إلى</v-list-subheader>
                  <v-list-item 
                    v-for="folder in userFolders"
                    :key="'single-' + folder.id"
                    @click="moveSingleMessageToFolder(folder, message)"
                  >
                    <template v-slot:prepend>
                      <v-icon :color="folder.color">mdi-folder</v-icon>
                    </template>
                    <v-list-item-title>{{ folder.name }}</v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item v-if="hasPermission('admin.mails.destroy')" @click="confirmDeleteSingleMessage(message)" class="text-error">
                    <template v-slot:prepend>
                      <v-icon color="error">mdi-delete</v-icon>
                    </template>
                    <v-list-item-title>حذف</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-list-item>
        </template>
      </v-list>
          </div>
        </v-expand-transition>
      </div>
      
      <!-- Loading More Indicator -->
      <div v-if="loadingMore" class="text-center pa-4">
        <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
        <div class="text-body-2 text-grey mt-2">جاري تحميل المزيد من الرسائل...</div>
      </div>
      
      <!-- No More Messages Indicator -->
      <div v-else-if="!hasMoreMails && messages.length > 0" class="text-center pa-4">
        <v-icon size="32" color="grey-lighten-1" class="mb-2">mdi-check-circle</v-icon>
        <div class="text-body-2 text-grey">تم تحميل جميع الرسائل</div>
      </div>
    </v-card>

    <!-- Message Dialog -->
    <v-dialog v-model="messageDialog" max-width="800px" scrollable>
      <v-card v-if="currentMessage">
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2">mdi-email</v-icon>
          {{ currentMessage.subject }}
          <v-spacer></v-spacer>
          <v-btn icon @click="messageDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-subtitle class="pb-0">
          <div class="d-flex align-center mb-2">
            <v-chip
              v-if="currentMessage.urgent"
              size="small"
              color="error"
              variant="flat"
              class="mr-2"
            >
              عاجل
            </v-chip>
            <v-icon
              v-if="currentMessage.important"
              color="warning"
              size="small"
              class="mr-1"
            >
              mdi-star
            </v-icon>
          </div>
          
          <div><strong>من:</strong> {{ currentMessage.senderDepartment }}</div>
          <div><strong>التاريخ:</strong> {{ formatFullDate(currentMessage.date) }}</div>
          <div><strong>الإشاري:</strong> {{ currentMessage.ref || 'غير متوفر' }}</div>
          <div><strong>النوع:</strong> {{ currentMessage.mailType || 'غير متوفر' }}</div>
                     <v-chip
                             v-for="marginalization in currentMessage.marginalizations"
                             :key="marginalization.id"
                             size="small"
                             color="info"
                             variant="outlined"
                             class="mr-1 mb-1"
                             :closable="hasPermission('admin.mail-marginalizations.destroy')?true:false"
                             close-icon="mdi-close"
                             @click:close=" confirmRemoveMarginalization(marginalization)"
                           >
                             {{ marginalization.marginalization.desc }}
                           </v-chip>
        </v-card-subtitle>
        
        <v-card-text>
          <div class="message-content mb-4" v-html="currentMessage.content.replace(/\n/g, '<br>')"></div>
          
          <v-divider v-if="currentMessage.attachments && currentMessage.attachments.length > 0" class="mb-4"></v-divider>
          
          <v-div v-if="currentMessage.attachments && currentMessage.attachments.length > 0">
            <h4 class="mb-2">المرفقات:</h4>
            <v-list density="compact">
              <v-list-item
                v-for="(attachment, index) in currentMessage.attachments"
                :key="attachment.name || `attachment-${index}`"
                class="attachment-item"
              >
                <template v-slot:prepend>
                  <v-icon :color="getAttachmentIcon(attachment.name).includes('pdf') ? 'red' : 'primary'">
                    {{ getAttachmentIcon(attachment.name) }}
                  </v-icon>
                </template>
                
                <v-list-item-title>{{ attachment.file_name || 'ملف غير معروف' }}</v-list-item-title>
                <v-list-item-subtitle>{{ attachment.file_size || 'حجم غير معروف' }}</v-list-item-subtitle>
                
                <template v-slot:append>
                  <v-btn
                    v-if="hasPermission('admin.mail-attachments.download')"
                    icon
                    size="small"
                    variant="text"
                    @click="downloadAttachment(attachment)"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </template>
              </v-list-item>
            </v-list>
          </v-div>
        </v-card-text>
        
        <v-card-actions>
          <v-btn v-if="hasPermission('admin.mails.store-reply')" color="primary" @click="replyToMessage">
            <v-icon start>mdi-reply</v-icon>
            رد
          </v-btn>
          
          <v-btn v-if="hasPermission('admin.mails.store-forward')" color="secondary" @click="forwardMessage">
            <v-icon start>mdi-forward</v-icon>
            إعادة توجيه
          </v-btn>
          
          <v-btn v-if="hasPermission('admin.mail-marginalizations.store')" color="info" variant="outlined" @click="openMarginalizationDialog(currentMessage)">
            <v-icon start>mdi-comment-plus</v-icon>
            إضافة تهميش
          </v-btn>
          
          <v-btn v-if="hasPermission('admin.mails.history')" color="primary" variant="outlined" @click="openTrackMailDialog(currentMessage)">
            <v-icon start>mdi-radar</v-icon>
            تتبع الرسالة
          </v-btn>
          
          <v-btn color="success" variant="outlined" @click="printMessage">
            <v-icon start>mdi-printer</v-icon>
            طباعة
          </v-btn>
          
          <v-spacer></v-spacer>
          
          <v-menu location="bottom">
            <template v-slot:activator="{ props }">
              <v-btn v-if="hasPermission('admin.mails.move')"
                v-bind="props"
                color="info"
                variant="outlined"
              >
                <v-icon start>mdi-folder-move</v-icon>
                نقل إلى مجلد
              </v-btn>
            </template>
            <v-list density="compact">
              <v-list-item
                v-for="folder in userFolders"
                :key="'dialog-' + folder.id"
                @click="moveSingleMessageToFolder(folder)"
              >
                <template v-slot:prepend>
                  <v-icon :color="folder.color">mdi-folder</v-icon>
                </template>
                <v-list-item-title>{{ folder.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          
          <v-btn v-if="hasPermission('admin.mails.destroy')"   color="error" variant="outlined" @click="confirmDeleteSingleMessage(currentMessage)">
            <v-icon start>mdi-delete</v-icon>
            حذف
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Create/Edit Folder Dialog -->
    <v-dialog v-model="createFolderDialog" max-width="600px">
      <v-card>
        <v-card-title class="text-h6">
          {{ editingFolder ? 'تعديل المجلد' : 'إنشاء مجلد جديد' }}
        </v-card-title>
        
        <v-form ref="folderFormRef" v-model="folderFormValid" @submit.prevent="saveFolder">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="folderForm.name"
                  label="اسم المجلد"
                  required
                  :rules="[v => !!v || 'اسم المجلد مطلوب']"
                  variant="outlined"
                  density="comfortable"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12">
                <v-textarea
                  v-model="folderForm.desc"
                  label="وصف المجلد"
                  variant="outlined"
                  density="comfortable"
                  rows="3"
                ></v-textarea>
              </v-col>
              
              <v-col cols="12">
                <v-select
                  v-model="folderForm.color"
                  label="لون المجلد"
                  :items="colorOptions"
                  item-title="name"
                  item-value="value"
                  variant="outlined"
                  density="comfortable"
                >
                  <template v-slot:selection="{ item }">
                    <v-icon :color="item.raw.value" class="mr-2">{{ item.raw.icon }}</v-icon>
                    {{ item.raw.name }}
                  </template>
                  <template v-slot:item="{ props, item }">
                    <v-list-item v-bind="props">
                      <template v-slot:prepend>
                        <v-icon :color="item.raw.value">{{ item.raw.icon }}</v-icon>
                      </template>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-card-text>
          
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="createFolderDialog = false">إلغاء</v-btn>
            <v-btn 
              color="primary" 
              type="submit"
              :disabled="!folderFormValid"
              :loading="loading"
            >
              {{ editingFolder ? 'تحديث' : 'إنشاء' }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Delete Folder Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="500px">
      <v-card>
        <v-card-title class="text-h6 text-error">
          <v-icon color="error" class="mr-2">mdi-delete-alert</v-icon>
          تأكيد الحذف
        </v-card-title>
        <v-card-text>
          هل أنت متأكد من حذف المجلد "<strong>{{ folderToDelete?.name }}</strong>"؟
          <br><br>
          <v-alert type="warning" density="compact" class="mt-2">
            سيتم حذف المجلد نهائياً ولا يمكن التراجع عن هذا الإجراء.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialog = false">إلغاء</v-btn>
          <v-btn 
            color="error" 
            @click="executeDeleteFolder"
            :loading="loading"
          >
            حذف نهائياً
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Move to Folder Success Dialog -->
    <v-dialog v-model="moveSuccessDialog" max-width="400px">
      <v-card>
        <v-card-title class="text-h6">
          تم النقل بنجاح
        </v-card-title>
        <v-card-text>
          تم نقل {{ selectedMessages.length }} رسالة إلى مجلد "{{ lastMovedToFolder?.name }}"
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="moveSuccessDialog = false"
          >
            موافق
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Marginalization Dialog -->
    <v-dialog v-model="marginalizationDialog" max-width="600px">
      <v-card>
        <v-card-title class="text-h6 d-flex align-center">
          <v-icon class="mr-2" color="info">mdi-comment-plus</v-icon>
          إضافة تهميش للرسالة
          <v-spacer></v-spacer>
          <v-btn icon @click="marginalizationDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-subtitle v-if="currentMailForMarginalization" class="pb-0">
          <div><strong>الموضوع:</strong> {{ currentMailForMarginalization.subject }}</div>
          <div><strong>المرسل:</strong> {{ currentMailForMarginalization.sender }}</div>
        </v-card-subtitle>
        
        <v-card-text>
          <v-select
            v-model="selectedMarginalization"
            :items="marginalizations"
            label="اختر التهميش"
            item-title="title"
            item-value="id"
            variant="outlined"
            :rules="[v => !!v || 'يرجى اختيار تهميش']"
          >
            <template v-slot:item="{ props, item }">
              <v-list-item v-bind="props">
                <v-list-item-title>{{ item.raw.title }}</v-list-item-title>
                <v-list-item-subtitle v-if="item.raw.desc">
                  {{ item.raw.desc }}
                </v-list-item-subtitle>
              </v-list-item>
            </template>
          </v-select>
          
          <v-autocomplete
            v-model="selectedDepartments"
            :items="availableDepartments"
            label="اختر الأقسام"
            item-title="name"
            item-value="id"
            variant="outlined"
            multiple
            chips
            closable-chips
            class="mt-4"
            :rules="[v => v && v.length > 0 || 'يرجى اختيار قسم واحد على الأقل']"
          >
            <template v-slot:chip="{ props, item }">
              <v-chip
                v-bind="props"
                :text="item.raw.name"
                class="ma-1"
                color="primary"
                variant="outlined"
              ></v-chip>
            </template>
          </v-autocomplete>
          
          <v-alert
            v-if="marginalizations.length === 0"
            type="info"
            density="compact"
            class="mt-3"
          >
            لا توجد تهميشات متاحة
          </v-alert>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            variant="text"
            @click="marginalizationDialog = false"
          >
            إلغاء
          </v-btn>
          <v-btn
            v-if="hasPermission('admin.mail-marginalizations.store')"
            color="primary"
            :disabled="!selectedMarginalization || !selectedDepartments.length"
            :loading="loading"
            @click="addMarginalizationToMail"
          >
            إضافة التهميش
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Remove Marginalization Confirmation Dialog -->
    <v-dialog v-model="removeMarginalizationDialog" max-width="500px">
      <v-card>
        <v-card-title class="text-h6 text-error">
          <v-icon color="error" class="mr-2">mdi-delete-alert</v-icon>
          تأكيد حذف التهميش
        </v-card-title>
        <v-card-text>
          هل أنت متأكد من حذف التهميش "<strong>{{ marginalizationToRemove?.marginalization?.desc }}</strong>"؟
          <br><br>
          <v-alert type="warning" density="compact" class="mt-2">
            سيتم حذف التهميش نهائياً ولا يمكن التراجع عن هذا الإجراء.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="removeMarginalizationDialog = false">إلغاء</v-btn>
          <v-btn 
            color="error" 
            @click="executeRemoveMarginalization"
            :loading="loading"
          >
            حذف نهائياً
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Single Mail Confirmation Dialog -->
    <v-dialog v-model="deleteMailDialog" max-width="500px">
      <v-card>
        <v-card-title class="text-h6 text-error">
          <v-icon color="error" class="mr-2">mdi-delete-alert</v-icon>
          تأكيد حذف الرسالة
        </v-card-title>
        <v-card-text>
          هل أنت متأكد من حذف الرسالة "<strong>{{ mailToDelete?.subject }}</strong>"؟
          <br><br>
          <v-alert type="warning" density="compact" class="mt-2">
            سيتم حذف الرسالة نهائياً ولا يمكن التراجع عن هذا الإجراء.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteMailDialog = false">إلغاء</v-btn>
          <v-btn 
            color="error" 
            @click="deleteSingleMessage"
            :loading="loading"
          >
            حذف نهائياً
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Selected Mails Confirmation Dialog -->
    <v-dialog v-model="deleteSelectedDialog" max-width="500px">
      <v-card>
        <v-card-title class="text-h6 text-error">
          <v-icon color="error" class="mr-2">mdi-delete-alert</v-icon>
          تأكيد حذف الرسائل المحددة
        </v-card-title>
        <v-card-text>
          هل أنت متأكد من حذف <strong>{{ selectedMessages.length }}</strong> رسالة محددة؟
          <br><br>
          <v-alert type="warning" density="compact" class="mt-2">
            سيتم حذف الرسائل نهائياً ولا يمكن التراجع عن هذا الإجراء.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteSelectedDialog = false">إلغاء</v-btn>
          <v-btn 
            color="error" 
            @click="deleteSelected"
            :loading="loading"
          >
            حذف نهائياً
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Track Mail Dialog -->
    <v-dialog v-model="trackMailDialog" max-width="1000px" scrollable>
      <v-card>
        <v-card-title class="text-h6 d-flex align-center">
          <v-icon class="mr-2" color="primary">mdi-radar</v-icon>
          تتبع الرسالة
          <v-spacer></v-spacer>
          <v-btn icon @click="trackMailDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-subtitle v-if="currentMailForTracking" class="pb-0">
          <div><strong>الموضوع:</strong> {{ currentMailForTracking.subject }}</div>
          <div><strong>الإشاري:</strong> {{ mailHistory?.ref || 'غير متوفر' }}</div>
          <div><strong>النوع:</strong> {{ currentMailForTracking.mail_type?.name || 'غير متوفر' }}</div>
        </v-card-subtitle>
        
        <v-card-text>
          <v-data-table
            :headers="trackingHeaders"
            :items="mailHistoryItems"
            :loading="trackingLoading"
            class="elevation-1"
            density="compact"
            :items-per-page="10"
          >
            <template #[`item.date`]="{ item }">
              <div class="text-body-2">
                {{ formatFullDate(item.date) }}
              </div>
            </template>
            
            <template #[`item.operation_type`]="{ item }">
              <v-chip
                :color="getOperationTypeColor(item.operation_type)"
                size="small"
                variant="outlined"
              >
                <v-icon start size="small">{{ getOperationTypeIcon(item.operation_type) }}</v-icon>
                {{ getOperationTypeText(item.operation_type) }}
              </v-chip>
            </template>
            
            <template #[`item.from_department`]="{ item }">
              <div class="d-flex align-center">
                <v-icon class="me-2" size="small" color="primary">mdi-office-building</v-icon>
                {{ item.from_department }}
              </div>
            </template>
            
            <template #[`item.to_departments`]="{ item }">
              <div class="d-flex flex-wrap ga-1">
                <v-chip
                  v-for="dept in item.to_departments"
                  :key="dept"
                  size="x-small"
                  color="info"
                  variant="outlined"
                >
                  {{ dept }}
                </v-chip>
              </div>
            </template>
            
            <template #[`item.sender`]="{ item }">
              <div class="d-flex align-center">
                <v-icon class="me-2" size="small" color="success">mdi-account</v-icon>
                {{ item.sender }}
              </div>
            </template>
          </v-data-table>
          
          <v-alert
            v-if="mailHistoryItems.length === 0 && !trackingLoading"
            type="info"
            variant="tonal"
            class="mt-4"
          >
            <v-icon>mdi-information</v-icon>
            لا يوجد تاريخ متاح لهذه الرسالة
          </v-alert>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            variant="text"
            @click="trackMailDialog = false"
          >
            إغلاق
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Hidden Print Template -->
    <div ref="printContent" style="display: none;">
      <div class="print-page-with-bg" v-if="currentMessage">
        <!-- Addressee Section -->
        <div class="print-addressee">
          <p>السيد / {{ getRecipientTitle() }}</p>
        </div>

        <!-- Mail Content -->
        <div class="print-mail-content">
          <div class="mail-body" v-html="currentMessage.content?.replace(/\n/g, '<br>')"></div>
        </div>

        <!-- Sender Section -->
        <div class="print-sender-section">
          <div class="sender-left-group">
            <div class="sender-info-text">
              <div class="sender-name"> {{ currentMessage.senderJobShort || '' }} {{ currentMessage.sender }}</div>
              <div class="sender-position">
                {{ currentMessage.senderJob || '' }} {{ currentMessage.senderDepartment || '' }}
              </div>
            </div>
            
            <div class="stamps-section">
            <!-- Department Stamp -->
            <div class="department-stamp">
              <img 
                v-if="currentMessage.senderDepartmentStamp"
                :src="currentMessage.senderDepartmentStamp" 
                alt="ختم القسم"
                class="stamp-image department-stamp-img"
              />
              <div v-else class="stamp-placeholder">
                <div class="stamp-text">ختم القسم</div>
              </div>
            </div>
            
            <!-- Sender Signature -->
            <div class="sender-signature">
              <img 
                v-if="currentMessage.senderStamp"
                :src="currentMessage.senderStamp" 
                alt="توقيع المرسل"
                class="signature-image"
              />
              <div v-else class="signature-placeholder">
                <div class="signature-line">التوقيع</div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userFolderService from '../services/userFolderService'
import mailService from '../services/mailService'
import marginalizationService from '../services/marginalizationService'
import { showSuccessAlert, showErrorAlert } from '@/utils/alertUtils'
import {  hasPermission, hasModule } from '@/utils/permissions'
import { mapGetters } from 'vuex'

export default {
  name: 'InboxView',
  data() {
    return {
      search: '',
      filter: 'all',
      selectAll: false,
      selectedMessages: [],
      expandedDates: {}, // Track which date sections are expanded
      showFilterMenu: false,
      messageDialog: false,
      currentMessage: null,
      createFolderDialog: false,
      moveSuccessDialog: false,
      lastMovedToFolder: null,
      folderFormValid: false,
      activeTab: 'all',
      editingFolder: null,
      loading: false,
      deleteDialog: false,
      folderToDelete: null,
      userFolders: [],
      folderForm: {
        name: '',
        desc: '',
        color: '#2196F3'
      },
      colorOptions: [
        { name: 'أزرق', value: '#2196F3', icon: 'mdi-circle' },
        { name: 'أحمر', value: '#F44336', icon: 'mdi-circle' },
        { name: 'أخضر', value: '#4CAF50', icon: 'mdi-circle' },
        { name: 'برتقالي', value: '#FF9800', icon: 'mdi-circle' },
        { name: 'بنفسجي', value: '#9C27B0', icon: 'mdi-circle' },
        { name: 'وردي', value: '#E91E63', icon: 'mdi-circle' },
        { name: 'أزرق فاتح', value: '#00BCD4', icon: 'mdi-circle' },
        { name: 'رمادي', value: '#607D8B', icon: 'mdi-circle' }
      ],
      messages: [], // Will be filled by API
      // Pagination properties
      lastMailId: null,
      hasMoreMails: true,
      loadingMore: false,
      // Marginalization properties
      marginalizationDialog: false,
      marginalizations: [],
      selectedMarginalization: null,
      currentMailForMarginalization: null,
      removeMarginalizationDialog: false,
      marginalizationToRemove: null,
      // Delete mail properties
      deleteMailDialog: false,
      mailToDelete: null,
      deleteSelectedDialog: false,
      // Track mail properties
      trackMailDialog: false,
      currentMailForTracking: null,
      mailHistory: null,
      trackingLoading: false,
      trackingHeaders: [
        { title: 'التاريخ', key: 'date', align: 'start' },
        { title: 'نوع العملية', key: 'operation_type', align: 'center' },
        { title: 'من القسم', key: 'from_department', align: 'start' },
        { title: 'إلى الأقسام', key: 'to_departments', align: 'start' },
        { title: 'المرسل', key: 'sender', align: 'start' }
      ],
      // Departments data
      allDepartments: [],
      selectedDepartments: []
    }
  },
  computed: {
    filteredMessages() {
      let result = [];
      
      // Get messages based on active tab
      if (this.activeTab === 'all') {
        // Show all messages from inbox plus all folder messages
        result = [...this.messages];
        // Add messages from all folders
        this.userFolders.forEach(folder => {
          if (folder.mails && folder.mails.length > 0) {
            const folderMessages = folder.mails.map(mail => this.mapMailToMessage(mail));
            result = result.concat(folderMessages);
          }
        });
      } else if (this.activeTab === 'add') {
        // Return empty for add tab
        result = [];
      } else {
        // Show messages from specific folder
        const selectedFolder = this.userFolders.find(f => f.id.toString() === this.activeTab);
        if (selectedFolder && selectedFolder.mails) {
          result = selectedFolder.mails.map(mail => this.mapMailToMessage(mail));
        }
      }
      
      // Apply search filter
      if (this.search) {
        const searchLower = this.search.toLowerCase();
        result = result.filter(message => 
          message.sender.toLowerCase().includes(searchLower) ||
          message.subject.toLowerCase().includes(searchLower) ||
          message.preview.toLowerCase().includes(searchLower) ||
          (message.priority && message.priority.toLowerCase().includes(searchLower))
        );
      }
      
      // Apply status filter
      if (this.filter === 'unread') {
        result = result.filter(message => !message.read);
      } else if (this.filter === 'read') {
        result = result.filter(message => message.read);
      } else if (this.filter === 'important') {
        result = result.filter(message => message.important);
      }
      
      // Remove duplicates based on mail ID
      const uniqueMessages = result.filter((message, index, self) => 
        index === self.findIndex(m => m.id === message.id)
      );
      
      return uniqueMessages.sort((a, b) => new Date(b.date) - new Date(a.date));
    },
    
    groupedMessages() {
      const groups = {};
      
      this.filteredMessages.forEach(message => {
        const messageDate = new Date(message.date);
        const dateKey = messageDate.toDateString();
        
        if (!groups[dateKey]) {
          groups[dateKey] = {
            date: messageDate,
            messages: []
          };
          // Set as expanded by default
          
            this.expandedDates[dateKey] = true;
          
        }
        //console.log('message 11111111111111111111111', message);
        groups[dateKey].messages.push(message);
      });
      
      // Convert to array and sort by date (newest first)
      return Object.values(groups).sort((a, b) => new Date(b.date) - new Date(a.date));
    },
    
    hasSelected() {
      return this.selectedMessages.length > 0;
    },
    
    otherFolders() {
      return this.userFolders.filter(folder => folder.id.toString() !== this.activeTab);
    },
    
    totalEmailCount() {
    
      return this.messages.length;
    },
    
    mailHistoryItems() {
      if (!this.mailHistory) return [];
      
      const items = [];
      
      // Add the original mail as the first item (SEND operation)
      items.push({
        date: this.mailHistory.sent_at || this.mailHistory.created_at,
        operation_type: 'send',
        from_department: this.mailHistory.sender_department?.name || 'غير محدد',
        to_departments: this.mailHistory.departments?.map(dept => dept.name) || [],
        sender: this.mailHistory.sender?.name || 'غير محدد'
      });
      
      // Add history items
      if (this.mailHistory.history && Array.isArray(this.mailHistory.history)) {
        this.mailHistory.history.forEach(historyItem => {
          let operationType = 'send'; // default
          
          // Determine operation type based on parent_id and forward_parent_id
          if (historyItem.parent_id && !historyItem.forward_parent_id) {
            operationType = 'reply';
          } else if (historyItem.forward_parent_id && !historyItem.parent_id) {
            operationType = 'forward';
          }
          
          items.push({
            date: historyItem.sent_at || historyItem.created_at,
            operation_type: operationType,
            from_department: historyItem.sender_department?.name || 'غير محدد',
            to_departments: historyItem.departments?.map(dept => dept.name) || [],
            sender: historyItem.sender?.name || 'غير محدد'
          });
        });
      }
      
      // Sort by date (newest first)
      return items.sort((a, b) => new Date(b.date) - new Date(a.date));
    },
    
    ...mapGetters(['sendPermissions']),
    
    // Filter departments based on current department's send permissions
    availableDepartments() {
      if (!this.allDepartments || this.allDepartments.length === 0) {
        return [];
      }
      
      // If no send permissions defined, allow sending to all active departments
      if (!this.sendPermissions || this.sendPermissions.length === 0) {
        return this.allDepartments.filter(dept => dept.active !== false);
      }
      
      // Filter departments based on send permissions
      return this.allDepartments.filter(dept => {
        const hasPermission = this.sendPermissions.includes(dept.id);
        const isActive = dept.active !== false;
        return hasPermission && isActive;
      });
    }
  },
  
  async mounted() {
    await this.loadUserFolders()
    await this.loadInboxMessages()
    await this.loadMarginalizations()
    await this.loadDepartments()
    
    // Add scroll listener for infinite scrolling
    this.setupInfiniteScroll()
  },

  beforeUnmount() {
    // Remove scroll listener
    this.removeInfiniteScroll()
  },

  methods: {
    async loadUserFolders() {
      try {
        this.loading = true
        const response = await userFolderService.getUserFolders({ sent: false })
        //console.log('Full user folders response:', response)
        // Filter folders where sent is false and try to support both response formats
        const foldersData = (response.data && response.data.data) || response.data || []
        this.userFolders = foldersData.filter(folder => folder.sent === false).map(folder => ({
          ...folder,
          emailCount: folder.mails ? folder.mails.length : 0
        }))
      } catch (error) {
        showErrorAlert(this.$store, error, 'فشل في تحميل المجلدات');
      } finally {
        this.loading = false
      }
    },

    async loadInboxMessages(isLoadMore = false) {
      try {
        //console.log('loadInboxMessages called', { isLoadMore, lastMailId: this.lastMailId, hasMoreMails: this.hasMoreMails });
        
        if (isLoadMore) {
          this.loadingMore = true
        } else {
          this.loading = true
          this.messages = [] // Reset messages for initial load
          this.lastMailId = null
          this.hasMoreMails = true
        }

        const response = await mailService.getInbox(this.lastMailId)
        //console.log('API response:', response);
        const newMails = response.data || []
        //console.log('New mails received:', newMails.length, 'mails');
        
        // Map API response to the messages array structure used in the UI
        const mappedMails = newMails.map(mail => ({
          id: mail.id,
          ref: mail.ref,
          sender: mail.sender?.name || '',
          senderJob: mail.sender_department_job?.name || '',
          senderJobShort: mail.sender.employee_title?.short_name || '',
          senderDepartment: mail.sender_department?.name || '',
          email: mail.sender?.email || '',
          subject: mail.subject,
          to: (mail.departments || []).filter(d => d.pivot?.recipient_type?.toUpperCase() === 'TO').map(d => d.name),
          cc: (mail.departments || []).filter(d => d.pivot?.recipient_type?.toUpperCase() === 'CC').map(d => d.name),
          priority: mail.priority?.name || '',
          senderStamp: mail.sender?.stamp_url || '',
          senderDepartmentStamp: mail.sender_department?.stamp_url || '',
          preview: mail.body ? mail.body.replace(/<[^>]*>/g, '').slice(0, 80) + (mail.body.replace(/<[^>]*>/g, '').length > 80 ? '...' : '') : '',
          content: mail.body,
          mailType: mail.mail_type?.name || '',
          date: mail.sent_at || mail.created_at,
          read: false, // You may want to update this if your API provides read/unread status
          important: false, // Update if your API provides this
          urgent: mail.priority?.level === 1 ? false : true, // Example logic
          attachment: (mail.attachments && mail.attachments.length > 0),
          attachments: mail.attachments || [],
          marginalizations: mail.marginalizations || []
        }))
        
        if (isLoadMore) {
          // Append new mails to existing ones
          //console.log('Appending', mappedMails.length, 'mails to existing', this.messages.length, 'mails');
          this.messages = [...this.messages, ...mappedMails]
        } else {
          // Replace with new mails for initial load
          //console.log('Setting initial', mappedMails.length, 'mails');
          this.messages = mappedMails
        }
        
        // Update pagination state
        if (mappedMails.length > 0) {
          this.lastMailId = mappedMails[mappedMails.length - 1].id
          this.hasMoreMails = mappedMails.length === 10 // If we got less than 10, no more mails
          //console.log('Updated pagination:', { lastMailId: this.lastMailId, hasMoreMails: this.hasMoreMails });
        } else {
          this.hasMoreMails = false
          //console.log('No more mails available');
        }
        
      } catch (error) {
        console.error('Error loading inbox messages:', error);
        showErrorAlert(this.$store, error, 'فشل في تحميل البريد الوارد');
      } finally {
        this.loading = false
        this.loadingMore = false
      }
    },

    openCreateFolderDialog() {
      this.editingFolder = null
      this.folderForm = {
        name: '',
        desc: '',
        color: '#2196F3'
      }
      this.folderFormValid = false
      this.createFolderDialog = true
    },

    editFolder(folder) {
      this.editingFolder = folder
      this.folderForm = {
        name: folder.name,
        desc: folder.desc || '',
        color: folder.color || '#2196F3'
      }
      this.folderFormValid = true
      this.createFolderDialog = true
    },
    hasPermission(permission) {
      // Prevent permission checks during logout to avoid DOM errors
      if (this.$store.state.isLoggingOut) {
        return false
      }
      return hasPermission(permission)
    },
    
    hasModule(moduleName) {
      // Prevent permission checks during logout to avoid DOM errors
      if (this.$store.state.isLoggingOut) {
        return false
      }
      return hasModule(moduleName)
    },

    async saveFolder() {
      try {
        this.loading = true
        
        let response;
        if (this.editingFolder) {
          response = await userFolderService.updateUserFolder(this.editingFolder.id, this.folderForm)
          showSuccessAlert(this.$store, response, 'تم تحديث المجلد بنجاح');
        } else {
          response = await userFolderService.createUserFolder({ ...this.folderForm, sent: false })
          showSuccessAlert(this.$store, response, 'تم إنشاء المجلد بنجاح');
        }
        
        this.createFolderDialog = false
        await this.loadUserFolders()
      } catch (error) {
        showErrorAlert(this.$store, error, 'فشل في حفظ المجلد');
      } finally {
        this.loading = false
      }
    },

    confirmDeleteFolder(folder) {
      this.folderToDelete = folder
      this.deleteDialog = true
    },

    async executeDeleteFolder() {
      try {
        this.loading = true
        const response = await userFolderService.deleteUserFolder(this.folderToDelete.id)
        
        showSuccessAlert(this.$store, response, 'تم حذف المجلد بنجاح');
        
        this.deleteDialog = false
        this.folderToDelete = null
        
        // If the deleted folder was active, switch to "all"
        if (this.activeTab === this.folderToDelete?.id.toString()) {
          this.activeTab = 'all'
        }
        
        await this.loadUserFolders()
      } catch (error) {
        showErrorAlert(this.$store, error, 'فشل في حذف المجلد');
      } finally {
        this.loading = false
      }
    },

    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedMessages = this.filteredMessages.map(m => m.id);
      } else {
        this.selectedMessages = [];
      }
    },
    
    toggleMessageSelection(messageId) {
      const index = this.selectedMessages.indexOf(messageId);
      if (index > -1) {
        this.selectedMessages.splice(index, 1);
      } else {
        this.selectedMessages.push(messageId);
      }
      
      // Update selectAll state
      this.selectAll = this.selectedMessages.length === this.filteredMessages.length;
    },
    
    toggleFilterMenu() {
      this.showFilterMenu = !this.showFilterMenu;
    },
    
    openMessage(message) {
      this.currentMessage = message;
      //console.log('currentMessage', this.currentMessage); 
      message.read = true;
      this.messageDialog = true;
    },
    
    async downloadAttachment(attachment) {
      if (!attachment.file_url) {
        showErrorAlert(this.$store, { message: 'رابط الملف غير متوفر' }, 'فشل في التحميل');
        return;
      }

      try {
        // Import axios for the download request
        const axios = (await import('axios')).default;
        
        //console.log('Downloading attachment:', attachment.file_name, 'from:', attachment.file_url);
        
        // Make request to download the file
        const response = await axios.get(attachment.file_url, {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          }
        });

        // Create blob and download link
        const blob = new Blob([response.data]);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = attachment.file_name || 'attachment';
        
        // Trigger download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Clean up object URL
        URL.revokeObjectURL(link.href);
        
        //console.log('✅ Download completed successfully');
        
      } catch (error) {
        console.error('❌ Attachment download failed:', error);
        showErrorAlert(this.$store, error, 'فشل في تحميل المرفق');
      }
    },
    
    async replyToMessage() {
      if (!this.currentMessage) return;
      
      try {
        this.loading = true;
        
        // Get the original mail details
        const response = await mailService.getMail(this.currentMessage.id);
        //console.log('Original mail response:', response);
        
        const originalMail =  response;
        //console.log('Original mail data:', originalMail);
        
        // Extract sender department from sender_department field
        let senderDepartmentId = null;
        if (originalMail.sender_department_id) {
          senderDepartmentId = originalMail.sender_department_id;
          //console.log('Sender department ID from sender_department:', senderDepartmentId);
        } else {
          //console.log('No sender_department found in:', originalMail);
        }
        
        // Extract CC departments from departments with recipient_type: "cc"
        let ccDepartmentIds = [];
        if (originalMail.departments && Array.isArray(originalMail.departments)) {
          ccDepartmentIds = originalMail.departments
            .filter(dept => dept.pivot && dept.pivot.recipient_type === 'cc')
            .map(dept => dept.id);
          //console.log('CC departments with recipient_type cc:', ccDepartmentIds);
        } else {
          //console.log('No departments found in:', originalMail.departments);
        }
        
        // Prepare reply data for compose dialog
        const replyData = {
          isReply: true,
          originalMail: originalMail,
          subject: `رد: ${this.currentMessage.subject}`,
          to_departments: senderDepartmentId ? [senderDepartmentId] : [],
          cc_departments: ccDepartmentIds,
          parent_id: this.currentMessage.id
        };
        
        //console.log('Reply data prepared:', replyData);
        
        // Emit event to parent to open compose dialog with reply data
        this.$emit('openComposeReply', replyData);
        
      } catch (error) {
        console.error('Error preparing reply:', error);
        showErrorAlert(this.$store, error, 'فشل في تحضير الرد');
      } finally {
        this.loading = false;
      }
    },
    
    async forwardMessage() {
      if (!this.currentMessage) return;
      
      try {
        this.loading = true;
        
        // Get the original mail details
        const response = await mailService.getMail(this.currentMessage.id);
        //console.log('Original mail response for forward:', response);
        
        const originalMail = response;
        //console.log('Original mail data for forward:', originalMail);
        
        // Prepare forward data for compose dialog
        const forwardData = {
          isForward: true,
          originalMail: originalMail,
          subject: `إعادة توجيه: ${this.currentMessage.subject}`,
          to_departments: [], // Empty - user can select
          cc_departments: [], // Empty - user can select
          forward_parent_id: this.currentMessage.id
        };
        
        //console.log('Forward data prepared:', forwardData);
        
        // Emit event to parent to open compose dialog with forward data
        this.$emit('openComposeForward', forwardData);
        
      } catch (error) {
        console.error('Error preparing forward:', error);
        showErrorAlert(this.$store, error, 'فشل في تحضير إعادة التوجيه');
      } finally {
        this.loading = false;
      }
    },
    
    markSingleAsRead(message) {
      message.read = true;
    },
    
    markSingleAsUnread(message) {
      message.read = false;
    },
    
    toggleImportant(message) {
      message.important = !message.important;
    },
    
    confirmDeleteSingleMessage(message) {
      this.mailToDelete = message
      this.deleteMailDialog = true
    },

    async deleteSingleMessage() {
      if (!this.mailToDelete) return

      try {
        this.loading = true
        
        // Call the API to delete the mail
        const response = await mailService.deleteMail(this.mailToDelete.id)

        showSuccessAlert(this.$store, response, 'تم حذف الرسالة بنجاح');
        
        this.deleteMailDialog = false
        this.mailToDelete = null
        
        // Close message dialog if it's open
        if (this.messageDialog) {
          this.messageDialog = false
        }
        
        // Refresh data to remove the deleted mail from UI
        await this.loadUserFolders()
        await this.loadInboxMessages()
        
      } catch (error) {
        console.error('Error deleting mail:', error)
        showErrorAlert(this.$store, error, 'فشل في حذف الرسالة');
      } finally {
        this.loading = false
      }
    },
    
    formatDate(date) {
      const messageDate = new Date(date);
      const now = new Date();
      
      // If today, show time
      if (messageDate.toDateString() === now.toDateString()) {
        return messageDate.toLocaleTimeString('ar-LY', { hour: '2-digit', minute: '2-digit' });
      }
      
      // If this year, show day and month
      if (messageDate.getFullYear() === now.getFullYear()) {
        return messageDate.toLocaleDateString('ar-LY', { day: 'numeric', month: 'short' });
      }
      
      // Otherwise show full date
      return messageDate.toLocaleDateString('ar-LY', { year: 'numeric', month: 'short', day: 'numeric' });
    },
    
    formatFullDate(date) {
      return new Date(date).toLocaleDateString('ar-LY', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    
    getAttachmentIcon(filename) {
      // Handle null, undefined, or empty filename
      if (!filename || typeof filename !== 'string') {
        return 'mdi-file-document-outline';
      }
      
      const extension = filename.split('.').pop().toLowerCase();
      
      switch (extension) {
        case 'pdf':
          return 'mdi-file-pdf-box';
        case 'doc':
        case 'docx':
          return 'mdi-file-word';
        case 'xls':
        case 'xlsx':
          return 'mdi-file-excel';
        case 'ppt':
        case 'pptx':
          return 'mdi-file-powerpoint';
        case 'jpg':
        case 'jpeg':
        case 'png':
          return 'mdi-file-image';
        default:
          return 'mdi-file-document-outline';
      }
    },
    
    markAsRead() {
      this.messages.forEach(message => {
        if (this.selectedMessages.includes(message.id)) {
          message.read = true;
        }
      });
      this.selectedMessages = [];
      this.selectAll = false;
    },
    
    markAsUnread() {
      this.messages.forEach(message => {
        if (this.selectedMessages.includes(message.id)) {
          message.read = false;
        }
      });
      this.selectedMessages = [];
      this.selectAll = false;
    },
    
    confirmDeleteSelected() {
      if (this.selectedMessages.length === 0) return
      this.deleteSelectedDialog = true
    },

    async deleteSelected() {
      if (this.selectedMessages.length === 0) return

      try {
        this.loading = true
        const selectedCount = this.selectedMessages.length
        
        // Delete all selected messages
        const deletePromises = this.selectedMessages.map(messageId => 
          mailService.deleteMail(messageId)
        )
        
        await Promise.all(deletePromises)

        showSuccessAlert(this.$store, { data: { message: `تم حذف ${selectedCount} رسالة بنجاح` } }, 
          `تم حذف ${selectedCount} رسالة بنجاح`);
        
        this.deleteSelectedDialog = false
        this.selectedMessages = []
        this.selectAll = false
        
        // Refresh data to remove deleted mails from UI
        await this.loadUserFolders()
        await this.loadInboxMessages()
        
      } catch (error) {
        console.error('Error deleting selected mails:', error)
        showErrorAlert(this.$store, error, 'فشل في حذف الرسائل');
      } finally {
        this.loading = false
      }
    },
    
    refreshMessages() {
      this.selectedMessages = [];
      this.selectAll = false;
      this.loadUserFolders();
      this.loadInboxMessages(); // Refresh inbox messages as well
    },
    
    selectRead() {
      this.selectedMessages = this.messages.filter(m => m.read).map(m => m.id);
      this.selectAll = false;
    },
    
    selectUnread() {
      this.selectedMessages = this.messages.filter(m => !m.read).map(m => m.id);
      this.selectAll = false;
    },
    
    async moveToFolder(folder) {
      if (this.selectedMessages.length === 0) return;
      
      try {
        this.loading = true;
        const selectedCount = this.selectedMessages.length;
        
        // Move all selected messages
        const movePromises = this.selectedMessages.map(messageId => 
          mailService.moveMail(messageId, folder.id)
        );
        
        await Promise.all(movePromises);
        
        this.lastMovedToFolder = folder;
        this.moveSuccessDialog = true;
        this.selectedMessages = [];
        this.selectAll = false;
        
        // Refresh data to reflect changes
        await this.loadUserFolders();
        await this.loadInboxMessages();
        
        showSuccessAlert(this.$store, { data: { message: `تم نقل ${selectedCount} رسالة إلى مجلد "${folder.name}" بنجاح` } }, 
          `تم نقل ${selectedCount} رسالة إلى مجلد "${folder.name}" بنجاح`);
        
      } catch (error) {
        showErrorAlert(this.$store, error, 'فشل في نقل الرسائل');
      } finally {
        this.loading = false;
      }
    },
    
    async moveSingleMessageToFolder(folder, message = null) {
      const targetMessage = message || this.currentMessage;
      if (!targetMessage) return;
      
      try {
        this.loading = true;
        
        await mailService.moveMail(targetMessage.id, folder.id);
        
        this.lastMovedToFolder = folder;
        this.moveSuccessDialog = true;
        
        if (this.messageDialog) {
          this.currentMessage = null;
          this.messageDialog = false;
        }
        
        // Refresh data to reflect changes
        await this.loadUserFolders();
        await this.loadInboxMessages();
        
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'success',
          color: 'success',
          icon: 'mdi-check-circle',
          timeout: 3000,
          closable: true,
          message: `تم نقل الرسالة إلى مجلد "${folder.name}" بنجاح`
        });
        
      } catch (error) {
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: 'فشل في نقل الرسالة: ' + (error.message || 'خطأ غير معروف')
        });
      } finally {
        this.loading = false;
      }
    },
    
    async moveToInbox() {
      if (this.selectedMessages.length === 0 || this.activeTab === 'all') return;
      
      try {
        this.loading = true;
        
        // Move all selected messages back to inbox
        const movePromises = this.selectedMessages.map(messageId => 
          mailService.moveMailToInbox(messageId)
        );
        
        await Promise.all(movePromises);
        
        this.selectedMessages = [];
        this.selectAll = false;
        
        // Refresh data to reflect changes
        await this.loadUserFolders();
        await this.loadInboxMessages();
        
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'success',
          color: 'success',
          icon: 'mdi-check-circle',
          timeout: 3000,
          closable: true,
          message: 'تم نقل الرسائل إلى البريد الوارد بنجاح'
        });
        
      } catch (error) {
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: 'فشل في نقل الرسائل: ' + (error.message || 'خطأ غير معروف')
        });
      } finally {
        this.loading = false;
      }
    },

    toggleDateExpansion(dateKey) {
      this.expandedDates[dateKey] = !this.expandedDates[dateKey];
    },
    
    formatDateHeader(date) {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      
      if (date.toDateString() === today.toDateString()) {
        return 'اليوم';
      } else if (date.toDateString() === yesterday.toDateString()) {
        return 'أمس';
      } else {
        return date.toLocaleDateString('ar-LY', { 
          weekday: 'long', 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric' 
        });
      }
    },
    
    formatTime(date) {
      return new Date(date).toLocaleTimeString('ar-LY', { 
        hour: '2-digit', 
        minute: '2-digit' 
      });
    },

    mapMailToMessage(mail) {
      //console.log('mail mapping', mail);
      return {
        id: mail.id,
        ref: mail.ref,
        sender: mail.sender?.name || '',
        senderJob: mail.sender_department_job?.name || '',
        senderJobShort: mail.sender?.employee_title?.short_name || '',
        mailType: mail.mail_type?.name || '',
        senderDepartment: mail.sender_department?.name || '',
        email: mail.sender?.email || '',
        subject: mail.subject,
        priority: mail.priority?.name || '',
        senderStamp: mail.sender?.stamp_url || '',
        senderDepartmentStamp: mail.sender_department?.stamp_url || '',
        preview: mail.body ? mail.body.replace(/<[^>]*>/g, '').slice(0, 80) + (mail.body.replace(/<[^>]*>/g, '').length > 80 ? '...' : '') : '',
        content: mail.body,
        date: mail.sent_at || mail.created_at,
        read: false, // You may want to update this if your API provides read/unread status
        important: false, // Update if your API provides this
        urgent: mail.priority?.level === 1 ? false : true, // Example logic
        attachment: (mail.attachments && mail.attachments.length > 0),
        attachments: mail.attachments || [],
        marginalizations: mail.marginalizations || []
      };
    },

    // Marginalization methods
    async loadMarginalizations() {
      try {
        const response = await marginalizationService.getMarginalizations()
        this.marginalizations = response.data?.data || response.data || []
      } catch (error) {
        console.error('Error loading marginalizations:', error)
        showErrorAlert(this.$store, error, 'فشل في تحميل التهميشات');
      }
    },

    async loadDepartments() {
      try {
        const departmentService = await import('@/services/departmentService');
        const response = await departmentService.default.getDepartments();
        this.allDepartments = response.data?.data || response.data || [];
      } catch (error) {
        console.error('Error loading departments:', error);
        showErrorAlert(this.$store, error, 'فشل في تحميل الأقسام');
      }
    },

    openMarginalizationDialog(message) {
      this.currentMailForMarginalization = message
      this.selectedMarginalization = null
      this.selectedDepartments = []
      this.marginalizationDialog = true
    },

    async addMarginalizationToMail() {
      if (!this.selectedMarginalization || !this.currentMailForMarginalization || !this.selectedDepartments.length) {
        return
      }

      try {
        this.loading = true
        
        // Call the API to add marginalization to mail with departments
        const response = await mailService.addMarginalizationToMail(
          this.currentMailForMarginalization.id,
          this.selectedMarginalization,
          this.selectedDepartments
        )

        showSuccessAlert(this.$store, response, 'تم إضافة التهميش بنجاح');
        
        this.marginalizationDialog = false
        this.currentMailForMarginalization = null
        this.selectedMarginalization = null
        this.selectedDepartments = []
       
      
        // Refresh data to show the new marginalization
        await this.loadUserFolders()
        await this.loadInboxMessages()
        
        // Update current message if dialog is open
        if (this.messageDialog && this.currentMessage) {
          // Find the updated message and update currentMessage
          const updatedMessage = this.filteredMessages.find(m => m.id === this.currentMessage.id)
          if (updatedMessage) {
            this.currentMessage = updatedMessage
          }
        }
        
      } catch (error) {
        console.error('Error adding marginalization:', error)
        showErrorAlert(this.$store, error, 'فشل في إضافة التهميش');
      } finally {
        this.loading = false
      }
    },

    confirmRemoveMarginalization(marginalization) {
      this.marginalizationToRemove = marginalization
      this.removeMarginalizationDialog = true
    },

    async executeRemoveMarginalization() {
      if (!this.marginalizationToRemove) return

      try {
        this.loading = true
        
        // Call the API to remove marginalization from mail
        const response = await mailService.removeMarginalizationFromMail(this.marginalizationToRemove.id)

        showSuccessAlert(this.$store, response, 'تم حذف التهميش بنجاح');
        
        this.removeMarginalizationDialog = false
        this.marginalizationToRemove = null
        
        // Refresh data to remove the marginalization from UI
        await this.loadUserFolders()
        await this.loadInboxMessages()
        
        // Update current message if dialog is open
        if (this.messageDialog && this.currentMessage) {
          // Find the updated message and update currentMessage
          const updatedMessage = this.filteredMessages.find(m => m.id === this.currentMessage.id)
          if (updatedMessage) {
            this.currentMessage = updatedMessage
          }
        }
        
      } catch (error) {
        console.error('Error removing marginalization:', error)
        showErrorAlert(this.$store, error, 'فشل في حذف التهميش');
      } finally {
        this.loading = false
      }
    },

    // Track mail methods
    openTrackMailDialog(message) {
      this.currentMailForTracking = message;
      this.trackMailDialog = true;
      this.loadMailHistory(message.id);
    },

    async loadMailHistory(mailId) {
      try {
        this.trackingLoading = true;
        this.mailHistory = null;
        
        // Call the mail history API
        const response = await mailService.getMailHistory(mailId);
        //console.log('Mail history response:', response);
        
        this.mailHistory = response.data || response;
        
      } catch (error) {
        console.error('Error loading mail history:', error);
        showErrorAlert(this.$store, error, 'فشل في تحميل تاريخ الرسالة');
      } finally {
        this.trackingLoading = false;
      }
    },

    getOperationTypeText(type) {
      switch (type) {
        case 'send':
          return 'إرسال';
        case 'reply':
          return 'رد';
        case 'forward':
          return 'إعادة توجيه';
        default:
          return 'غير معروف';
      }
    },

    getOperationTypeColor(type) {
      switch (type) {
        case 'send':
          return 'success';
        case 'reply':
          return 'primary';
        case 'forward':
          return 'info';
        default:
          return 'grey';
      }
    },

    getOperationTypeIcon(type) {
      switch (type) {
        case 'send':
          return 'mdi-send';
        case 'reply':
          return 'mdi-reply';
        case 'forward':
          return 'mdi-forward';
        default:
          return 'mdi-email';
      }
    },

    // Infinite scroll methods
    setupInfiniteScroll() {
      // Since the whole page scrolls, use window scroll events
      //console.log('Setting up infinite scroll for window');
      window.addEventListener('scroll', this.handleScroll);
    },

    removeInfiniteScroll() {
      //console.log('Removing infinite scroll listener');
      window.removeEventListener('scroll', this.handleScroll);
    },

    handleScroll() {
      if (this.loadingMore || !this.hasMoreMails) {
        //console.log('Scroll ignored - loadingMore:', this.loadingMore, 'hasMoreMails:', this.hasMoreMails);
        return;
      }
      
      const threshold = 300; // Load more when 300px from bottom
      
      // Use window/document scroll properties
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
      );
      
      const distanceFromBottom = documentHeight - (scrollTop + windowHeight);
      
      //console.log('Window scroll data:', { 
        //scrollTop, 
        //windowHeight, 
        //documentHeight, 
        //distanceFromBottom, 
        //threshold,
        //shouldLoadMore: distanceFromBottom <= threshold
      //});
      
      if (distanceFromBottom <= threshold) {
        //console.log('Loading more mails triggered by window scroll');
        this.loadMoreMails();
      }
    },

    async loadMoreMails() {
      if (this.loadingMore || !this.hasMoreMails) {
        //console.log('loadMoreMails ignored - loadingMore:', this.loadingMore, 'hasMoreMails:', this.hasMoreMails);
        return;
      }
      
      //console.log('Loading more mails, lastMailId:', this.lastMailId);
      await this.loadInboxMessages(true);
    },

    // Print functionality - Same format as DashboardView
    async printMessage() {
      if (!this.currentMessage) return;
      
      try {
        // Check if this is original print or copy
        const isOriginalPrint = !this.currentMessage.printed_at;
        //console.log('Print tracking:', { 
          //mailId: this.currentMessage.id, 
          //printedAt: this.currentMessage.printed_at, 

          //isOriginalPrint 
        //});

        // Get the background image as base64
        const backgroundImage = await this.getImageAsBase64();
        
        // Create a new window for printing
        const printWindow = window.open('', '_blank');
        
        if (!printWindow) {
          this.$store.dispatch('alerts/showAlert', {
            id: Date.now(),
            type: 'error',
            color: 'error',
            icon: 'mdi-alert-circle',
            timeout: 3000,
            closable: true,
            message: 'تعذر فتح نافذة الطباعة'
          });
          return;
        }
        
        // Calculate content length to determine if we need multiple pages
        const contentText = this.stripHtml(this.currentMessage.content || '');
        const contentLength = contentText.length;
        
        // More accurate estimation based on actual content area
        // First page has less space (45% height ≈ 1800 chars), continuation pages have more (65% ≈ 2600 chars)
        const firstPageChars = 1800;
        const continuationPageChars = 2600;
        
        let estimatedPages = 1;
        let remainingContent = contentLength;
        
        if (remainingContent > firstPageChars) {
          remainingContent -= firstPageChars;
          estimatedPages += Math.ceil(remainingContent / continuationPageChars);
        }
        
        //console.log('Print Debug:', {
          //contentLength,
          //  firstPageChars,
          //    continuationPageChars,
          //  estimatedPages:
          //willUseMultiPage: estimatedPages > 1,
          //isOriginalPrint
        //});
        
        // Create multiple page divs
        let pagesHtml = '';
        
        if (estimatedPages <= 1) {
          // Single page layout
          pagesHtml = `
            <div class="print-page-with-bg">
              ${!isOriginalPrint ? '<div class="copy-watermark">نسخة</div>' : ''}
              <!-- Date and Ref Section -->
              <div class="print-date-ref">
                <div class="ref-number">الإشاري: ${this.currentMessage.ref || 'غير متوفر'}</div>
                <div class="mail-date">التاريخ: ${this.formatPrintDate(this.currentMessage.date)}</div>
              </div>
              <div class="print-type-barcode">
                <div class="mail-type-label">النوع: ${this.currentMessage.mailType || 'غير متوفر'}</div>
                <svg class="barcode-svg" data-ref="${this.currentMessage.ref || ''}"></svg>
              </div>

              <!-- Mail Content Section -->
              <div class="print-mail-content first-page">
                <div class="mail-recipients">السادة : ${(this.currentMessage.to || []).join(' , ') || 'غير محدد'}</div>
                <div class="mail-subject">بخصوص : ${this.currentMessage.subject || 'بدون موضوع'}</div>
                <div class="mail-body">${this.currentMessage.content?.replace(/\n/g, '<br>') || ''}</div>
              </div>

              <!-- Sender Section -->
              <div class="print-sender-section">
                <div class="sender-copy-note">
                  <div><i class="mdi mdi-archive"></i> <span style="font-weight: bold;">صورة إلى :</span> الأرشــيــف</div>
                  ${(this.currentMessage.cc || []).map(name => `<div class="copy-recipient">${name}</div>`).join('')}
                </div>
                <div class="sender-left-group">
                  <div class="sender-info-text">
                    <div class="sender-name text-center">${this.currentMessage.senderJobShort || '' } ${this.currentMessage.sender || ''}</div>
                    <div class="sender-position text-center">${this.currentMessage.senderJob || '' } ${this.currentMessage.senderDepartment || ''}</div>
                  </div>
                  <div class="stamps-section">
                    <div class="sender-signature">
                      ${this.currentMessage.senderStamp ? 
                        `<div class="signature-image" style="background-image: url('${this.currentMessage.senderStamp}');"></div>` :
                        '<div class="signature-placeholder"><div class="signature-line">التوقيع</div></div>'
                      }
                    </div>
                    <div class="department-stamp">
                      ${this.currentMessage.senderDepartmentStamp ? 
                        `<div class="department-stamp-img" style="background-image: url('${this.currentMessage.senderDepartmentStamp}');"></div>` :
                        '<div class="stamp-placeholder"><div class="stamp-text">ختم القسم</div></div>'
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          `;
        } else {
          // Multi-page layout - split content accurately
          let currentIndex = 0;
          
          for (let page = 0; page < estimatedPages; page++) {
            const isFirstPage = page === 0;
            const isLastPage = page === estimatedPages - 1;
            
            let pageChars = isFirstPage ? firstPageChars : continuationPageChars;
            let endIndex = Math.min(currentIndex + pageChars, contentLength);
            let pageContent = contentText.slice(currentIndex, endIndex);
            
            // Try to break at word boundaries when possible (but not on last page)
            if (!isLastPage && endIndex < contentLength) {
              const lastSpaceIndex = pageContent.lastIndexOf(' ');
              if (lastSpaceIndex > pageContent.length * 0.7) { // Only adjust if space is reasonably near the end
                pageContent = pageContent.slice(0, lastSpaceIndex);
                endIndex = currentIndex + lastSpaceIndex;
              }
            }
            
            // Convert back to HTML format
            pageContent = pageContent.replace(/\n/g, '<br>');
            
            pagesHtml += `
              <div class="print-page-with-bg">
                ${isFirstPage && !isOriginalPrint ? '<div class="copy-watermark">نسخة</div>' : ''}
                ${isFirstPage ? `
                  <!-- Date and Ref Section -->
                  <div class="print-date-ref">
                    <div class="ref-number">الإشاري: ${this.currentMessage.ref || 'غير متوفر'}</div>
                    <div class="mail-date">التاريخ: ${this.formatPrintDate(this.currentMessage.date)}</div>
                  </div>
                  <div class="print-type-barcode">
                    <div class="mail-type-label">النوع: ${this.currentMessage.mailType || 'غير متوفر'}</div>
                    <svg class="barcode-svg" data-ref="${this.currentMessage.ref || ''}"></svg>
                  </div>
                ` : ''}

                <!-- Mail Content Section -->
                <div class="print-mail-content ${isFirstPage ? 'first-page' : 'continuation-page'}">
                  ${isFirstPage ? `
                    <div class="mail-recipients">السادة : ${(this.currentMessage.to || []).join(' , ') || 'غير محدد'}</div>
                    <div class="mail-subject">بخصوص : ${this.currentMessage.subject || 'بدون موضوع'}</div>
                  ` : ''}
                  <div class="mail-body">${pageContent}</div>
                </div>

                ${isLastPage ? `
                  <!-- Sender Section -->
                  <div class="print-sender-section">
                    <div class="sender-copy-note">
                      <div><i class="mdi mdi-archive"></i> <span style="font-weight: bold;">صورة إلى :</span> الأرشــيــف</div>
                      ${(this.currentMessage.cc || []).map(name => `<div class="copy-recipient">${name}</div>`).join('')}
                    </div>
                    <div class="sender-left-group">
                      <div class="sender-info-text">
                        <div class="sender-name">${this.currentMessage.sender || ''}</div>
                        <div class="sender-position">${this.getSenderJobTitle()}</div>
                      </div>
                      <div class="stamps-section">
                        <div class="sender-signature">
                          ${this.currentMessage.senderStamp ? 
                            `<div class="signature-image" style="background-image: url('${this.currentMessage.senderStamp}');"></div>` :
                            '<div class="signature-placeholder"><div class="signature-line">التوقيع</div></div>'
                          }
                        </div>
                        <div class="department-stamp">
                          ${this.currentMessage.senderDepartmentStamp ? 
                            `<div class="department-stamp-img" style="background-image: url('${this.currentMessage.senderDepartmentStamp}');"></div>` :
                            '<div class="stamp-placeholder"><div class="stamp-text">ختم القسم</div></div>'
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                ` : ''}
              </div>
            `;
            
            currentIndex = endIndex;
          }
        }
        
        printWindow.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>طباعة المراسلة</title>
            <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@200..1000&display=swap" rel="stylesheet">
            <style>
              * { 
                margin: 0; 
                padding: 0; 
                box-sizing: border-box; 
                font-family: 'cairo', sans-serif; 
              }
              body { 
                font-family: 'cairo', sans-serif; 
                direction: rtl; 
                margin: 0;
                padding: 0;
              }
              @page { 
                size: A4; 
                margin: 0; 
              }
              @media print { 
                body { margin: 0; padding: 0; }
                .print-page-with-bg { box-shadow: none; margin: 0; }
              }
              
              .print-page-with-bg {
                width: 210mm;
                height: 297mm;
                margin: 0 auto;
                font-family: 'cairo', sans-serif;
                color: black;
                position: relative;
                padding: 0;
                page-break-after: always;
                background-color: white;
                background-image: url('data:image/png;base64,${backgroundImage}');
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
              }
              
              .print-page-with-bg:last-child {
                page-break-after: auto;
              }
              
              /* Date and Ref Section - Top Right with margin for header */
              .print-date-ref {
                position: absolute;
                top: 15%;
                right: 15mm;
                text-align: right;
                color: #004aad;
                font-size: 14px;
                line-height: 1.6;
              }

              .print-type-barcode {
                position: absolute;
                top: 15%;
                left: 15mm;
                text-align: center;
                color: #004aad;
                font-size: 14px;
              }

              .mail-type-label {
                font-weight: bold;
                margin-bottom: 6px;
              }

              .barcode-svg {
               background: #fff;
              padding: 10px;
                display: block;
              }
              
              .ref-number, .mail-date {
                margin-bottom: 8px;
                font-weight: bold;
              }
              
              /* Mail Content Section */
              .print-mail-content.first-page {
                position: absolute;
                top: 25%; /* Below header and date/ref section */
                left: 20mm;
                right: 20mm;
                height: 45%; /* Fixed height to prevent overflow into footer */
                text-align: right;
                overflow: hidden;
              }
              
              .print-mail-content.continuation-page {
                position: absolute;
                top: 15%; /* Below header (10% + 5% buffer) */
                left: 20mm;
                right: 20mm;
                height: 65%; /* More space on continuation pages */
                text-align: right;
                overflow: hidden;
              }
              
              .mail-recipients {
                font-size: 15px;
                font-weight: bold;
                margin-bottom: 10px;
                text-align: right;
              }

              .mail-subject {
                font-size: 15px;
                font-weight: bold;
                margin-bottom: 15px;
                text-align: right;
                text-decoration: underline;
              }
              
              .mail-body {
                font-size: 14px;
                line-height: 1.8;
                text-align: justify;
                text-indent: 20px;
                word-wrap: break-word;
                overflow-wrap: break-word;
              }
              
              /* Sender Section - Always at bottom with margin for footer */
              .print-sender-section {
                position: absolute;
                bottom: 10%; /* Above footer (5% + 5% buffer) */
                left: 20mm;
                right: 20mm;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                min-height: 120px;
              }

              .sender-left-group {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
              }
              
              .sender-info-text {
                text-align: center;
                margin-bottom: 10px;
              }

              .sender-copy-note {
                font-size: 14px;
                align-self: flex-end;
              }

              .copy-recipient {
                font-size: 14px;
                line-height: 1.6;
              }

              .copy-recipient::before {
                content: '\\200B صورة إلى : ';
                visibility: hidden;
                font-weight: bold;
              }
              
              .sender-name {
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 5px;
              }
              
              .sender-position {
                font-size: 14px;
                margin-bottom: 10px;
              }
              
              .stamps-section {
                display: flex;
                align-items: flex-end;
                gap: 20px;
              }
              
              .department-stamp {
                text-align: center;
                margin-left: 10px;
              }
              
              .department-stamp-img {
                width: 100px;
                height: 100px;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
                border-radius: 50%;
              }
              
              .stamp-placeholder {
                width: 100px;
                height: 100px;
                border: 2px solid black;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(255, 255, 255, 0.8);
              }
              
              .stamp-text {
                font-size: 12px;
                font-weight: bold;
                text-align: center;
              }
              
              .sender-signature {
                text-align: center;
              }
              
              .signature-image {
                width: 75px;
                height: 75px;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
              }
              
              .signature-placeholder {
                width: 75px;
                height: 75px;
                border: 1px solid black;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(255, 255, 255, 0.8);
              }
              
              .signature-line {
                font-size: 12px;
                font-weight: bold;
                text-align: center;
              }
              
              /* Copy watermark */
              .copy-watermark {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(-45deg);
                font-size: 80px;
                font-weight: bold;
                color: rgba(200, 200, 200, 0.3);
                z-index: 1;
                pointer-events: none;
                user-select: none;
                font-family: 'cairo', sans-serif;
              }
            </style>
          </head>
          <body>
            ${pagesHtml}
          </body>
          </html>
        `);

        printWindow.document.close();
        printWindow.focus();

        const barcodeScript = printWindow.document.createElement('script');
        barcodeScript.src = 'https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js';
        barcodeScript.onload = function() {
          var svgs = printWindow.document.querySelectorAll('.barcode-svg');
          for (var i = 0; i < svgs.length; i++) {
            var val = svgs[i].getAttribute('data-ref') || 'N/A';
            try {
              printWindow.JsBarcode(svgs[i], val, {
                format: 'CODE128',
                width: 2,
                height: 40,
                displayValue: false,
                margin: 10
              });
            } catch(e) { console.error('Barcode error:', e, 'value:', val); }
          }
        };
        printWindow.document.head.appendChild(barcodeScript);
        
        setTimeout(() => {
          printWindow.print();
          printWindow.close();
        }, 2500);
        
        // Mark as printed if this is the original print
        if (isOriginalPrint) {
          try {
            await mailService.markAsPrinted(this.currentMessage.id);
            //console.log('Mail marked as printed successfully');
            // Update the local message object to reflect the change
            this.currentMessage.printed_at = new Date().toISOString();
          } catch (markError) {
            console.error('Error marking mail as printed:', markError);
            // Don't show error to user as the print was successful
          }
        }
        
      } catch (error) {
        console.error('Error printing message:', error);
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: 'فشل في الطباعة: ' + (error.message || 'خطأ غير معروف')
        });
      }
    },

    formatPrintDate(date) {
      return new Date(date).toLocaleDateString('ar-LY', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      })
    },

    // Helper methods for print functionality
    async getImageAsBase64() {
      try {
        const response = await fetch(require('@/assets/printbg.png'));
        const blob = await response.blob();
        
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            const base64 = reader.result.split(',')[1];
            resolve(base64);
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      } catch (error) {
        console.error('Error loading background image:', error);
        return '';
      }
    },

    getRecipientTitle() {
      // Get the first to_department for the recipient title
      // Since currentMessage doesn't have the same structure as DashboardView,
      // we'll use the sender department as a fallback
      return `مدير ${this.currentMessage.senderDepartment || 'القسم'}`;
    },

    getSenderJobTitle() {
      // Get sender job title with department
      const senderName = this.currentMessage.sender || 'موظف';
      const departmentName = this.currentMessage.senderDepartment || '';
      return departmentName ? `${senderName} - ${departmentName}` : senderName;
    },

    stripHtml(html) {
      return html.replace(/<[^>]*>/g, '');
    }

  }
}
</script>

<style scoped>
.inbox-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.inbox-toolbar {
  border-radius: 8px;
  background-color: #f8f9fa;
}

.inbox-list {
  flex-grow: 1;
  overflow-y: auto;
  border-radius: 8px;
}

.search-field {
  width: 240px;
}

.unread-message {
  background-color: rgba(232, 240, 254, 0.5);
}

.selected-message {
  background-color: rgba(232, 240, 254, 0.8);
}

.message-content {
  font-size: 14px;
  line-height: 1.6;
}

.attachment-item {
  border-radius: 4px;
  transition: background-color 0.2s;
}

.attachment-item:hover {
  background-color: #f5f5f5;
}

/* RTL specific styles */
.v-list-item__prepend {
  margin-left: 8px !important;
  margin-right: 0 !important;
}

.v-input--checkbox .v-input__slot {
  justify-content: flex-end;
}

/* New styles for date headers */
.date-header {
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.date-header:hover {
  background-color: #f0f0f0;
}

.date-header.expanded {
  background-color: #f0f0f0;
}

.transition-transform {
  transition: transform 0.3s ease-in-out;
}

.rotated {
  transform: rotate(90deg);
}

/* Mail row layout styles */
.mail-row {
  width: 100%;
  gap: 12px;
}

.sender-section {
  flex: 0 0 180px;
  min-width: 180px;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
}

.priority-section {
  flex: 0 0 80px;
  min-width: 80px;
  max-width: 80px;
  text-align: center;
}

.subject-section {
  flex: 0 0 200px;
  min-width: 200px;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.preview-section {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 12px;
}

.time-section {
  flex: 0 0 120px;
  min-width: 120px;
  max-width: 120px;
  text-align: right;
}

.time-section .v-chip {
  font-size: 10px;
  height: 18px;
}

/* Print Styles */
@media print {
  * {
    --webkit-print-color-adjust: exact !important;
   --color-adjust: exact !important;
  }
  
  body {
    margin: 0;
    padding: 0;
  }
  
  .print-page-with-bg {
    box-shadow: none !important;
  }
}

/* Print Page with Background */
.print-page-with-bg {
  width: 210mm;
  height: 297mm;
  margin: 0 auto;
  background-image: url('@/assets/printbg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  font-family: 'cairo', sans-serif;
  color: black;
  page-break-after: always;
  position: relative;
  padding: 0;
  background-color: white;
}

/* Addressee Section - positioned after header space */
.print-addressee {
  position: absolute;
  top: 30%; /* Adjust based on your background image header height */
  right: 10%;
  text-align: right;
  margin-bottom: 20px;
}

.print-addressee p {
  font-size: 16px;
  font-weight: bold;
  margin: 3px 0;
  line-height: 1.4;
}

.print-addressee .respectful {
  margin-bottom: 15px;
}

/* Mail Content Section */
.print-mail-content {
  position: absolute;
  top: 160mm; /* Position below addressee */
  left: 20mm;
  right: 20mm;
  text-align: right;
}

.mail-recipients {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: right;
}

.mail-subject {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 15px;
  text-align: right;
  text-decoration: underline;
}

.mail-body {
  font-size: 14px;
  line-height: 1.8;
  text-align: justify;
  text-indent: 20px;
  margin-bottom: 20mm;
  max-height: 80mm; /* Limit height to prevent overflow */
  overflow: hidden;
}

/* Sender Section - positioned at bottom */
.print-sender-section {
  position: absolute;
  bottom: 40mm; /* Position above footer space */
  left: 20mm;
  right: 20mm;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.sender-left-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.sender-info-text {
  text-align: center;
  margin-bottom: 10px;
}

.sender-copy-note {
  font-size: 14px;
  align-self: flex-end;
}

.copy-recipient {
  font-size: 14px;
  line-height: 1.6;
}

.sender-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.sender-position {
  font-size: 14px;
  margin-bottom: 10px;
}

.stamps-section {
  display: flex;
  align-items: flex-end;
  gap: 20px;
}

/* Department Stamp */
.department-stamp {
  text-align: center;
  margin-left: 10px;
}

.department-stamp-img {
  width: 100px;
  height: 100px;
  object-fit: contain;
  border-radius: 50%;
}

.stamp-placeholder {
  width: 100px;
  height: 100px;
  border: 2px solid black;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
}

.stamp-text {
  font-size: 12px;
  font-weight: bold;
  text-align: center;
}

/* Sender Signature */
.sender-signature {
  text-align: center;
}

.signature-image {
  width: 150px;
  height: 100px;
  object-fit: contain;
}

.signature-placeholder {
  width: 150px;
  height: 100px;
  border: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
}

.signature-line {
  font-size: 12px;
  font-weight: bold;
  text-align: center;
}
</style> 